<svg [class]="innerClass" [style]="'fill:' + color">
	@if (name.length > 0) {
		<use [attr.href]="environment.contextRoot + '/assets/svg/sprites.svg#' + name"></use>
	} @else {
		<use [attr.href]="url"></use>
	}
</svg>
